export default "__VITE_ASSET__CjGvZtpv__"